import { useSettings } from '~/@mid_settings/settings'
import { Button } from '~/shadcn/ui/button/button'
import { CommonTooltip } from '~/@mid_ui/common-tooltip/CommonTooltip'
import { BoosterIcon } from '~/@mid_ui/icons/BoosterIcon'
import type { WalletSchema } from '../../_project_types/wallet.types'
import { hasAvailableFutureDispoForBooster } from './boosterProject.utils'
import { useBoosterProjectSetting } from './useBoosterProjectSetting'

type BoosterProjectTooltipProps = {
  investorWallet: WalletSchema
  availableFutureRevenueFixed: number
}

function BoosterProjectTooltip({
  investorWallet,
  availableFutureRevenueFixed,
}: BoosterProjectTooltipProps) {
  // check, ci je BOOSTER_PROJECT enabled v settings
  const { isAvailable } = useBoosterProjectSetting()
  if (!isAvailable) return false

  // check, ci ma user dostatocne future dispo a vi je mensie, minimalny vklad na projekte
  const hasEnoughFutureDispo = hasAvailableFutureDispoForBooster(
    availableFutureRevenueFixed,
    investorWallet
  )
  if (!hasEnoughFutureDispo) return null

  return (
    <CommonTooltip
      icon={<BoosterIcon className="w-5 h-5" />}
      content={<BoosterTooltipContent />}
    />
  )
}

function BoosterTooltipContent() {
  const { getLandingPageLink } = useSettings()

  return (
    <div
      onClick={(e) => {
        e.stopPropagation()
      }}
      className="flex flex-col">
      <div className="flex flex-col gap-2">
        <p className="font-black text-[15px]">Investuj očakávané prostriedky</p>
        <p className="text-[13px] font-normal leading-normal text-left">
          Prinášame Vám možnosť reinvestovať prostriedky, ktoré očakávate.
        </p>
        <Button variant="accent" size="xs" className="max-w-max" asChild>
          <a
            href={getLandingPageLink('booster')}
            target="_blank"
            rel="noopener noreferrer">
            Chcem vedieť viac
          </a>
        </Button>
      </div>
    </div>
  )
}

export { BoosterProjectTooltip, BoosterTooltipContent }
